import React from "react";
import { formattedPrice } from "../../utils";
import styles from "./styles.module.scss";
function calculateTotals(array) {
  return array.reduce(
    (totals, item) => {
      totals.totalNetPayableAmount += item.totalNetPayableAmount || 0;
      totals.totalBalanceAmount += item.totalBalanceAmount || 0;
      totals.totalGrossAmount += item.totalGrossAmount || 0;
      totals.totalPaidAmount += item.totalPaidAmount || 0;

      return totals;
    },
    {
      totalNetPayableAmount: 0,
      totalBalanceAmount: 0,
      totalGrossAmount: 0,
      totalPaidAmount: 0,
    }
  );
}

const RegularChargesTotal = ({ rows }) => {
  const totalRow = calculateTotals(rows);
  return (
    <>
      <div></div>
      <div>
        <div className="text-bold text-dark" style={{ minWidth: "18rem" }}>
          Grand Total for Regular Course Charges
        </div>
      </div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div className={`${styles["amount-cell"]} text-bold text-dark`}>
        {formattedPrice(totalRow.totalGrossAmount)}
      </div>
      <div className={`${styles["amount-cell"]} text-bold text-dark`}>
        {formattedPrice(totalRow.totalNetPayableAmount)}
      </div>
      <div className={`${styles["amount-cell"]} text-bold text-dark`}>
        {formattedPrice(totalRow.totalPaidAmount)}
      </div>
      <div className={`${styles["amount-cell"]} text-bold text-dark`}>
        {(formattedPrice(Math.round(totalRow.totalBalanceAmount)))}
      </div>
      <div></div>
      <div></div>
    </>
  );
};

export default RegularChargesTotal;
